import { makeStyles, TextField } from '@material-ui/core';
import { FormControl } from '@mui/material';
import styles from '../../styles/TextInput.module.scss';

const textFieldStyles = makeStyles(() => ({
    root: {
        '& .MuiFormLabel-root': {
            minHeight: '5rem',
            fontSize: '1.4rem',
            lineHeight: 'normal',
            fontFamily: 'Montserrat',
            fontWeight: 500,
        },
        '& label + .MuiInput-formControl': {
            marginTop: '32px',
        },
        '& .MuiInputBase-input': { fontSize: '1.5rem' },
    },
    MuiFormControl: {
        '& .MuiFormControl-root': { minWidth: '100%' },
    },
}));

export const SimpleTextInput = ({
    id,
    name,
    label,
    required,
    value,
    onChange,
}: {
    id: string;
    label: string;
    required: boolean;
    name: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
    const classes = textFieldStyles();
    return (
        <div className={styles.formItem}>
            <div className={styles.form}>
                <FormControl className={classes.MuiFormControl}>
                    <TextField
                        // onKeyUp={() => trigger(name)}
                        className={classes.root}
                        id={id}
                        label={label}
                        type={'text'}
                        name={name}
                        required={required}
                        value={value}
                        onChange={onChange}
                        autoComplete={label}
                        variant="standard"
                    />
                </FormControl>
            </div>
        </div>
    );
};
